import styled from 'styled-components';

import { Box } from 'components/Box';
import { breakpoints } from 'theme';

const buttonBarHeight = '67px';

export const ButtonBarContainer = styled.div`
  display: none;
  height: ${buttonBarHeight};
  @media (max-width: ${breakpoints[2]}) {
    display: block;
  }
`;

export const ButtonBar = styled(Box)`
  margin-bottom: 0;
  position: fixed;
  height: ${buttonBarHeight};
  width: 100%;
  left: 0;
  bottom: 0;
  background: white;
  box-shadow: 0 -3px 4px 1px rgba(0, 0, 0, 0.15);
  & > button,
  & > a {
    flex-grow: 1;
    &:first-child {
      margin-left: 16px;
    }
    margin-right: 16px;
  }
`;
